import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import {
    EFTabIotNotSelectPc,
    EFTabIotSelectPc,
    EFTabApNotSelectPc,
    EFTabApSelectPc,
    EFTabBluetoothNotSelectPc,
    EFTabBluetoothSelectPc,
} from '@/components/UI/svg/appDownload';
import EFVideo from '@/components/UI/EFVideo';

export default function IotComp() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('app');
    const [activeTab, setActiveTab] = useState(0);
    const [selectTab, setSelectTab] = useState({});

    const data = [
        {
            title: t('quickGuideChild.tab1'),
            desc: t('quickGuideChild.iot-desc'),
            video: ['/video/app/pc/iot-video.mp4', '/video/app/pc/iot-video.webm'],
            svg: <EFTabIotNotSelectPc width="28px" height="28px" />,
            selectSvg: <EFTabIotSelectPc width="28px" height="28px" />,
        },
        {
            title: t('quickGuideChild.tab3'),
            desc: t('quickGuideChild.direct-desc'),
            video: ['/video/app/pc/wifi-video.mp4', '/video/app/pc/wifi-video.webm'],
            svg: <EFTabApNotSelectPc width="28px" height="28px" />,
            selectSvg: <EFTabApSelectPc width="28px" height="28px" />,
        },
        {
            title: t('quickGuideChild.tab2'),
            desc: t('quickGuideChild.bluetooth-desc'),
            video: ['/video/app/pc/bluetooth-video.mp4', '/video/app/pc/bluetooth-video.webm'],
            svg: <EFTabBluetoothNotSelectPc width="28px" height="28px" />,
            selectSvg: <EFTabBluetoothSelectPc width="28px" height="28px" />,
        },
    ];

    const clickTab = (index: number) => {
        setActiveTab(index);
        setSelectTab(data[index]);
    };

    useEffect(() => {
        setSelectTab(data[activeTab]);
    }, []);

    return (
        <div className={css.iotComp}>
            <div className="iot-comp">
                <div className="tab-box">
                    {data.map((item: any, index) => (
                        <div className={`item-box ${activeTab === index ? 'active' : ''}`} key={index} onClick={() => clickTab(index)}>
                            {activeTab === index ? item.selectSvg : item.svg}
                            <span className="tab-item">{item.title}</span>
                        </div>
                    ))}
                </div>
                <div className="box">
                    <div className="desc">{selectTab.desc}</div>
                    <div className="video-box">
                        <EFVideo key={selectTab.title} sources={selectTab.video} className="video" />
                    </div>
                </div>
            </div>
        </div>
    );
}
